import { render, staticRenderFns } from "./AuthenticatePlatformButton.vue?vue&type=template&id=ddb47c6c&scoped=true"
import script from "./AuthenticatePlatformButton.vue?vue&type=script&lang=js"
export * from "./AuthenticatePlatformButton.vue?vue&type=script&lang=js"
import style0 from "./AuthenticatePlatformButton.vue?vue&type=style&index=0&id=ddb47c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb47c6c",
  null
  
)

export default component.exports